<!-- shows a user's photo stream when they are logged in, but when not logged in, it should show registration and login forms -->

<template>
    <div class="dashboard">
        <!-- loads a MyPhotos component to show the photo stream of the logged in user, or a Login component if they are not logged in -->
        <MyPhotos v-if="user" />
        <Login v-else />
    </div>
</template>

<script>
    //when you import a component,save it as a component and use it in the template
    import MyPhotos from '@/components/MyPhotos.vue';
    import Login from '@/components/Login.vue';

    export default {
        name: 'dashboard',
        components: {
            MyPhotos,
            Login,
        },
        computed: {
            user() {
                return this.$root.$data.user;
            }
        }
    }
</script>

<style scoped>
    .dashboard {
        padding-top: 10px;
    }
</style>